import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../../assets/images/logo_new.svg";
import Constant from "../../util/constant";
import { toggleBodySidebarClasses } from "../../util/sidebarToggle";

/**
 * Left navigation for CLUB_MANAGER and CLUB_EMPLOYEE (role-based items).
 */
const SidebarClubManagerContent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const role = window.localStorage.getItem("role");
  const isManager = role === Constant.ROLES.CLUB_MANAGER;
  const isSalesAnalysisRoute = location.pathname.includes("club-sales-analysis");
  const salesReportSection =
    new URLSearchParams(location.search).get("section") === "event-end"
      ? "event-end"
      : "sales";
  const isEventsRoute = location.pathname.includes("events-list");
  const [isEventsSubMenuOpen, setEventsSubMenuOpen] = useState(isEventsRoute);
  const [isSalesSubMenuOpen, setSalesSubMenuOpen] = useState(
    isSalesAnalysisRoute
  );
  const homeTo =
    role === Constant.ROLES.CLUB_EMPLOYEE
      ? "/club-offline-sale"
      : "/club-sales-analysis?section=sales";

  const toggleSlider = () => {
    toggleBodySidebarClasses();
  };

  const toggleSalesSubMenu = () => {
    setSalesSubMenuOpen(!isSalesSubMenuOpen);
  };

  return (
    <div id="sidebar-menu">
      <div className="navbar-brand-box">
        <Link to={homeTo} className="logo logo-dark">
          <span className="logo-sm">
            <img src={logo} alt="RizzTix" height="22" />
          </span>
          <span className="logo-lg">
            <img src={logo} alt="RizzTix" />
          </span>
        </Link>
      </div>
      <ul className="metismenu list-unstyled" id="side-menu">
        <li className="menu-title">{t("CLUB_MANAGER_SIDEBAR_SECTION")}</li>
        <li>
          <div
            className={
              isSalesAnalysisRoute
                ? "active logoutMemu has-arrow"
                : "has-arrow logoutMemu"
            }
            onClick={toggleSalesSubMenu}
          >
            <div className="left-menu">
              <i className="bx bx-line-chart font-size-18 me-1" />
              <span>{t("CLUB_MANAGER_SALES_ANALYSIS")}</span>
            </div>
          </div>
          <ul
            role="menu"
            className={`sub-menu ${
              isSalesSubMenuOpen ? "open" : "genres-management"
            }`}
          >
            <li
              className={
                isSalesAnalysisRoute && salesReportSection === "sales"
                  ? "active"
                  : ""
              }
              onClick={toggleSlider}
            >
              <Link role="menuitem" to="/club-sales-analysis?section=sales">
                {t("CLUB_ANALYSIS_TAB_SALES")}
              </Link>
            </li>
            {isManager ? (
              <li
                className={
                  isSalesAnalysisRoute && salesReportSection === "event-end"
                    ? "active"
                    : ""
                }
                onClick={toggleSlider}
              >
                <Link
                  role="menuitem"
                  to="/club-sales-analysis?section=event-end"
                >
                  {t("CLUB_SALES_MENU_EVENT_END_REPORT")}
                </Link>
              </li>
            ) : null}
          </ul>
        </li>
        {isManager && (
          <li>
            <div
              className={
                isEventsRoute
                  ? "active logoutMemu has-arrow"
                  : "has-arrow logoutMemu"
              }
              onClick={() => setEventsSubMenuOpen(!isEventsSubMenuOpen)}
            >
              <div className="left-menu">
                <i className="bx bx-calendar-event font-size-18 me-1" />
                <span>{t("CLUB_MANAGER_EVENTS_MENU")}</span>
              </div>
            </div>
            <ul
              role="menu"
              className={`sub-menu ${
                isEventsSubMenuOpen ? "open" : "genres-management"
              }`}
            >
              <li
                className={
                  isEventsRoute && !location.pathname.includes("event-phases")
                    ? "active"
                    : ""
                }
                onClick={toggleSlider}
              >
                <Link role="menuitem" to="/events-list">
                  {t("EVENTS_LIST")}
                </Link>
              </li>
              <li
                className={
                  location.pathname.includes("event-phases") ? "active" : ""
                }
                onClick={toggleSlider}
              >
                <Link role="menuitem" to="/events-list/event-phases">
                  {t("EVENT_PHASES_MENU")}
                </Link>
              </li>
            </ul>
          </li>
        )}
                {isManager && (
          <li>
            <NavLink
              to="/club-website"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-globe font-size-18 me-1" />
                <span>{t("CLUB_WEBSITE_EDITOR_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-catalog"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-package font-size-18 me-1" />
                <span>{t("CATALOG_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-employees"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-group font-size-18 me-1" />
                <span>{t("CLUB_EMPLOYEES_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-table-booking"
              className={({ isActive }) =>
                isActive || location.pathname.includes("/table-booking")
                  ? "active"
                  : "inactive"
              }
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-grid-alt font-size-18 me-1" />
                <span>{t("TABLE_BOOKING_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-cashiers"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-money font-size-18 me-1" />
                <span>{t("CLUB_CASHIERS_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-guestlist"
              className={({ isActive }) =>
                isActive && !location.pathname.includes("/bulk-import")
                  ? "active"
                  : "inactive"
              }
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-user-plus font-size-18 me-1" />
                <span>{t("GUESTLIST_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {isManager && (
          <li>
            <NavLink
              to="/club-guestlist/bulk-import"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-spreadsheet font-size-18 me-1" />
                <span>{t("GUESTLIST_BULK_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
        {role === Constant.ROLES.CLUB_EMPLOYEE && (
          <li>
            <NavLink
              to="/club-offline-sale"
              className={({ isActive }) => (isActive ? "active" : "inactive")}
              onClick={toggleSlider}
            >
              <div className="left-menu">
                <i className="bx bx-purchase-tag font-size-18 me-1" />
                <span>{t("OFFLINE_SALE_MENU")}</span>
              </div>
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SidebarClubManagerContent;
